import React, { useState } from 'react'
import { connect } from 'react-redux'
import TextField from './TextField'
import { Grid, Tabs, Tab, withStyles } from '@material-ui/core'
import language from 'utils/vast-languagepack'
import Fields from './Fields'
import Font from './Font'
import Background from './Background'
import ButtonInfo from './ButtonInfo'

const styles = (theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
	flexContainer: {
		justifyContent: 'space-between',
	},
	tabsRoot: {
		borderBottom: '1px solid #e8e8e8',
		margin: '-5px -7px 12px -7px',
		width: '100%',
	},
	tabsIndicator: {
		backgroundColor: '#1890ff',
	},
	tabRoot: {
		'@media (min-width: 960px)': {
			fontSize: 8,
			marginRight: 5,
		},
		'@media (min-width: 1050px)': {
			fontSize: 9,
			marginRight: 9,
		},
		'@media (min-width: 1104px)': {
			fontSize: 10,
		},
		'@media (min-width: 1158px)': {
			fontSize: 11,
		},
		'@media (min-width: 1212px)': {
			fontSize: 12,
		},
		// fontSize: 12,
		textTransform: 'initial',
		minWidth: 0,
		marginRight: 9,
		fontWeight: theme.typography.fontWeightRegular,
		// marginRight: theme.spacing.unit * 4,
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		'&:hover': {
			color: '#40a9ff',
			opacity: 1,
		},
		'&$tabSelected': {
			color: '#1890ff',
			fontWeight: theme.typography.fontWeightMedium,
		},
		'&:focus': {
			color: '#40a9ff',
		},
	},
	tabSelected: {},
	labelContainer: {
		padding: 0,
	},
	lookAndFeel: {
		maxHeight: 700,
		// height: 505,
		overflow: 'visible',
		paddingTop: 5,
		paddingRight: 5,
		[theme.breakpoints.down('sm')]: {
			maxHeight: 'calc(100vh - 237px)',
			overflow: 'visible',
			// paddingTop: 5,
			// paddingRight: 5,
		},
	},
})

const FormInfo = ({ classes, formTypeSelected }) => {
	const [value, setValue] = useState(0)

	function handleChange(event, newValue) {
		setValue(newValue)
	}

	const description = [
		<TextField
			property="embedType"
			label={language.signupform.add.labels.embedType}
			select
			items={[
				{
					value: 'embedded',
					label: language.signupform.add.labels.embedForm,
				},
				{ value: 'popover', label: language.signupform.add.labels.popover },
			]}
		/>,
		<TextField property="title" label={language.signupform.add.labels.title} />,
		<TextField
			property="titleTextColor"
			label={language.signupform.add.labels.titleTextColor}
			color
		/>,
		<TextField
			property="description"
			label={language.signupform.add.labels.description}
		/>,
		<TextField
			property="descriptionTextColor"
			label={language.signupform.add.labels.descriptionTextColor}
			placeholder="#000000"
			color
		/>,
	].map((textField, idx) => (
		<Grid key={`textFieldFormInfo${idx}`} item xs={12}>
			{textField}
		</Grid>
	))

	const valueArr =
		formTypeSelected === 'signup'
			? [description, <Fields />, <Font />, <Background />, <ButtonInfo />]
			: [description, <Font />, <Background />, <ButtonInfo />]

	return (
		<Grid
			style={{ backgroundColor: '#fff' }}
			justify="center"
			container
			spacing={24}
		>
			<Tabs
				classes={{
					root: classes.tabsRoot,
					indicator: classes.tabsIndicator,
					flexContainer: classes.flexContainer,
				}}
				value={value}
				indicatorColor="primary"
				textColor="primary"
				onChange={handleChange}
			>
				<Tab
					classes={{
						root: classes.tabRoot,
						selected: classes.tabSelected,
						labelContainer: classes.labelContainer,
					}}
					disableRipple
					label="Description"
				/>
				{formTypeSelected === 'signup' && (
					<Tab
						classes={{
							root: classes.tabRoot,
							selected: classes.tabSelected,
							labelContainer: classes.labelContainer,
						}}
						disableRipple
						label="Fields"
					/>
				)}
				<Tab
					classes={{
						root: classes.tabRoot,
						selected: classes.tabSelected,
						labelContainer: classes.labelContainer,
					}}
					disableRipple
					label="Font"
				/>
				<Tab
					classes={{
						root: classes.tabRoot,
						selected: classes.tabSelected,
						labelContainer: classes.labelContainer,
					}}
					disableRipple
					label="Background"
				/>
				<Tab
					classes={{
						root: classes.tabRoot,
						selected: classes.tabSelected,
						labelContainer: classes.labelContainer,
					}}
					disableRipple
					label="Button"
				/>
			</Tabs>
			<Grid
				justify="center"
				container
				spacing={24}
				className={classes.lookAndFeel}
			>
				{valueArr[value]}
			</Grid>
		</Grid>
	)
}

export default connect(
	(state) => ({
		formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
	}),
	null,
)(withStyles(styles)(FormInfo))
